import css from './index.module.scss';
import { useLang } from '@/i18n';
import { useEffect, useRef, useState } from 'react';
import EcoVideo from 'eco-design/base/eco-video';
import useDeviceDetect from '@/utils/hooks/useDeviceDetect';
import EcoLink from 'eco-design/base/eco-link';

const M: React.FC = () => {
    const { t } = useLang('ats.M');
    const { isPad, isH5 } = useDeviceDetect();
    const [video, setVideo] = useState('');

    const sectionRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!sectionRef.current) return;
        const title = sectionRef.current?.querySelector('.title');
        const desc = sectionRef.current?.querySelector('.desc');
        const ani1 = AniContainer.create({
            triggerElement: sectionRef.current,
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                title?.classList.add('enter');
                desc?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    title?.classList.remove('enter');
                    desc?.classList.remove('enter');
                }
            },
        });
        const ani2 = AniContainer.create({
            triggerElement: '.smart-gateway-M .btn',
            triggerHook: 1,
            offset: '20%',
            duration: '100%',
            onEnter: () => {
                const btn = document.querySelector('.smart-gateway-M .btn');
                btn?.classList.add('enter');
            },
            onProcess: (process: number) => {
                if (process <= 0) {
                    const btn = document.querySelector('.smart-gateway-M .btn');
                    btn?.classList.remove('enter');
                }
            },
        });
        const ani3 = AniContainer.create({
            triggerElement: '.smart-gateway-J',
            triggerHook: 1,
            onEnter: () => !video && setVideo('https://websiteoss.ecoflow.com/upload/video/1760002206676/ATS%E4%BD%BF%E7%94%A8.mp4'),
        });
        const ani4 = AniContainer.create({
            triggerElement: `.${css.section} .bg-video`,
            triggerHook: 1,
            offset: '30%',
            onEnter: () => {
                const video: HTMLVideoElement | null = document.querySelector(`.${css.section} video`);
                if (video) {
                    video.currentTime = 0;
                    video.play();
                }
            },
        });
        return () => {
            ani1.destroy?.();
            ani2.destroy?.();
            ani3.destroy?.();
            ani4.destroy?.();
        };
    }, []);
    return (
        <section
            className={`${css.section} smart-gateway-M GtmModuleData-section`}
            id="smart-gateway-M"
            data-section-id={'smart-gateway-M'}
            data-section-title={t('M_title')}
            ref={sectionRef}
        >
            <div className="bg-video">
                {video && (
                    <EcoVideo
                        pc={video}
                        loop
                        poster={
                            isPad || isH5
                                ? 'https://websiteoss.ecoflow.com/upload/image/1760170628108/m_7%E5%A4%A9%E8%90%BD%E5%9C%B0(%E8%A7%86%E9%A2%91).jpg'
                                : 'https://websiteoss.ecoflow.com/upload/image/1760170628636/pc_7%E5%A4%A9%E8%90%BD%E5%9C%B0(%E8%A7%86%E9%A2%91).jpg'
                        }
                    />
                )}
            </div>
            <div className="info">
                <div className="title ani-1">{t('title')}</div>
                <div className="desc ani-2">{t('desc')}</div>
            </div>
            <EcoLink
                className="btn GtmModuleData-btn-href"
                href="https://us.ecoflow.com/products/installation-service?variant=54527686869065"
                dataLayer={{
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: 'Turnkey Installation Service',
                    position: 'Product Preview',
                    display_type: 'none',
                    module_referral: 'none',
                    jump_module: 'none',
                    __btn_id1: `${css.section} .btn`,
                    __btn_id2: 'https://us.ecoflow.com/products/installation-service?variant=54527686869065',
                    __btn_type: 'href',
                }}
                target="_blank"
                rel="noreferrer"
            >
                <span>{t('btn')}</span>
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="29" viewBox="0 0 28 29" fill="none">
                    <g clipPath="url(#clip0_4622_13229)">
                        <path
                            d="M14 26.0918C20.6274 26.0918 26 20.7192 26 14.0918C26 7.46438 20.6274 2.0918 14 2.0918C7.37258 2.0918 2 7.46438 2 14.0918C2 20.7192 7.37258 26.0918 14 26.0918Z"
                            fill="#3F68E0"
                        />
                        <path
                            d="M12.7178 19.208L17.5004 14.4254L17.588 14.338L12.6963 9.44629"
                            stroke="white"
                            strokeWidth="1.75"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_4622_13229">
                            <rect width="28" height="28" fill="white" transform="translate(0 0.0917969)" />
                        </clipPath>
                    </defs>
                </svg>
            </EcoLink>
        </section>
    );
};

export default M;
